// src/api/menu.js
import client from './client.js';

export const menuAPI = {
  getMenu: () => client.get('/menu'),
  getMegaMenu: (categoryId) => client.get(`/menu/${categoryId}`),
};